<div class="modal-body modal-scss">
  <form [formGroup]="actionResponse">
    <div class="row align-items-center">
      <div class="col-3 mb-3 align-items-center">
        <div
          class="actionStatusMargins"
          [ngClass]="{ orangeAction: currentAction.action.traiteLe === null, greenAction: currentAction.action.traiteLe !== null }">
          {{ currentAction?.action?.action }}
        </div>
        @if (currentAction.action.echeance) {
          <div class="echeanceDate">{{ 'action.forThe' | translate }} {{ currentAction.action.echeance | momentFormat: 'DD/MM/YYYY' }}</div>
        }
      </div>
      <div class="col-9 align-items-center">
        <div>
          @if (currentAction.action.transmissionUserName) {
            <span class="boldText">{{ currentAction.action.transmissionUserName }} </span>
          }
          <i class="bi bi-arrow-right"></i>
          @if (currentAction.action.type === 'SERVICE') {
            <span class="boldText"> {{ currentAction.action.name }} ({{ 'action.service' | translate }})</span>
          }
          @if (currentAction.action.type === 'DESTINATAIRE') {
            <span class="boldText">
              {{ currentAction.action.contactName ? currentAction.action.contactName : currentAction.action.libre }}
              @if (currentAction.action.libre) {
                <span class="boldText"> ({{ 'action.freeRecipient' | translate }})</span>
              }
            </span>
          }
          @if (currentAction.action.traiteLe === null) {
            <span
              ><i> ( {{ currentAction.action.transmisDate | momentFormat: 'DD/MM/YYYY' }} )</i></span
            >
          }
        </div>
        <div (click)="openMail(currentAction)">
          <i class="bi bi-box-arrow-up-right fs-13px blue-text cursor--pointer"></i
          ><span class="blue-text cursor--pointer wordBreak">
            {{ 'action.mail' | translate }} {{ currentAction.mailId }} - {{ currentAction.objet }}</span
          >
        </div>
        <div>
          @if (currentAction.action.message) {
            <span
              ><i class="wordBreak">« {{ currentAction.action.message }} »</i></span
            >
          }
          @if (!currentAction.action.message) {
            <span> / ({{ 'action.noMessage' | translate }})</span>
          }
        </div>
      </div>
    </div>
    <div class="row">
      @if (typeOfAnswer === null) {
        <div class="col-12">
          <div class="form-group">
            <h4 class="custom-h4-title">{{ 'action.response' | translate }}</h4>
            <textarea
              rows="5"
              cols="30"
              [placeholder]="'action.insertResponse' | translate"
              formControlName="Response"
              class="super-compos-input-text form-control w-100"
              pInputTextarea></textarea>
          </div>
        </div>
      }
      @if (typeOfAnswer === 'Question') {
        <div class="col-12 mb-2 mt-2">
          <div class="d-flex flex-column form-group align-items-center justify-content-center">
            <span class="custom-h4-title me-2 mb-1">{{ 'action.action' | translate }}</span>
            <p-selectButton
              class="selectButtonWorkflowAction"
              [options]="questionActions"
              formControlName="questionAnswer"
              optionLabel="label"
              optionValue="value"
              (onChange)="changeSelectButtonValue($event)">
              <ng-template pTemplate="item" let-item>
                <span id="selectBtnBacs{{ item.id }}">{{ item.label | translate }}</span>
              </ng-template>
            </p-selectButton>
          </div>
        </div>
        <div [ngTemplateOutlet]="commentDivForActions"></div>
      }
      @if (typeOfAnswer === 'WorkflowVariableService') {
        <div class="col-12 mb-4 mt-2 p-fluid">
          <span class="custom-h4-title me-2 mb-1">{{ 'action.chooseService' | translate }}</span>
          <p-treeSelect
            #treeSelect
            appendTo="body"
            id="p-treeSelect-action-response-modal"
            class="treeSelect"
            selectionMode="single"
            [emptyMessage]="'noResultFound' | translate"
            [filter]="true"
            [filterBy]="'label'"
            [filterPlaceholder]="'global.filterPlaceholder' | translate"
            [filterMode]="'strict'"
            [options]="listOfServices"
            [placeholder]="'pleaseSelectAService' | translate"
            [metaKeySelection]="false"
            (onNodeSelect)="select($event)"
            (onNodeUnselect)="unselect()"></p-treeSelect>
        </div>
        <div [ngTemplateOutlet]="commentDivForActions"></div>
      }
      @if (showStatutInput) {
        <div class="col-12 mt-2">
          <div class="form-group">
            <h4 class="custom-h4-title">{{ 'action.status' | translate }}</h4>
            <p-dropdown
              appendTo="body"
              styleClass="w-100"
              [options]="status | sort: 'ordreAffichage' : 'ASC'"
              [placeholder]="'action.selectStatus' | translate"
              [showClear]="true"
              formControlName="Statut">
            </p-dropdown>
          </div>
        </div>
      }
    </div>
    <div class="mt-2 row">
      <div class="col-md-12 d-flex justify-content-between">
        <i-button
          [disabled]="!actionResponse.valid"
          (click)="sendResponse(false)"
          [text]="'global.register' | translate"
          styleClass="bottomButton blue">
        </i-button>
        <i-button
          [disabled]="!actionResponse.valid"
          (click)="sendResponse(true)"
          [text]="'action.saveAndProcess' | translate"
          styleClass="bottomButton green">
        </i-button>
      </div>
    </div>
  </form>
</div>

<p-confirmDialog
  key="remplacantActionResponseModal"
  #cd
  appendTo="body"
  styleClass="super-compos-modal-content confirmModal"
  header="Confirmation"
  icon="bi bi-exclamation-triangle"
  baseZIndex="1000">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" [label]="'global.no' | translate" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'global.yes' | translate" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>

<ng-template #commentDivForActions>
  <div class="col-12" [formGroup]="actionResponse">
    <div class="form-group">
      <h4 class="custom-h4-title">{{ 'action.comment' | translate }}</h4>
      <textarea
        rows="5"
        cols="30"
        [placeholder]="'action.comment' | translate"
        formControlName="commentaires"
        class="super-compos-input-text form-control w-100"
        pInputTextarea></textarea>
    </div>
  </div>
</ng-template>
